import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface TextInputProps {
    id?: string;
    value?: string;
    onChange: (value: string) => void;
    placeholder?: string;
    readOnly?: boolean;
    error?: string;
    className?: string;
}

export function TextInput({
    id,
    value,
    onChange,
    placeholder,
    readOnly,
    error,
    className,
}: TextInputProps) {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleBlur = () => {
        onChange(inputValue);
    };

    const inputClassName = `${error ? "border-red-500" : ""} ${readOnly ? "bg-gray-50" : ""} ${className || ""}`;

    return (
        <div className="w-full">
            <Input
                id={id}
                type="text"
                value={inputValue}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnly}
                className={inputClassName}
                placeholder={placeholder}
            />
            {error && (
                <p className="text-xs font-normal text-red-600 mt-1 break-words w-full">
                    {error}
                </p>
            )}
        </div>
    );
}
